// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"147":"abd94ea5","580":"4175bde5","581":"87b02722"}[chunkId] + ".chunk.js";
};